import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class Drawer {
  /**
   * The HTML element of the drawer.
   */
  private $drawer: HTMLElement;

  /**
   * The HTML element of the toggle button.
   */
  private $toggle: HTMLElement;

  /**
   * Flag to indicate if the drawer is currenty open.
   */
  private isOpen: boolean = false;

  /**
   * Initializes the drawer.
   *
   * @param $toggle The HTML element of the toggle button
   * @param $drawer The HTML element of the drawer
   */
  constructor($toggle: HTMLElement, $drawer: HTMLElement) {
    this.$toggle = $toggle;
    this.$drawer = $drawer;

    this.$toggle.addEventListener('click', (event) => this.onToggleClick(event));
    window.addEventListener('resize', () => this.onWindowResize());
  }

  /**
   * Called when the user clicks on the toggle button.
   *
   * @param event The event arguments
   */
  private onToggleClick(event: MouseEvent): void {
    event.preventDefault();

    if (!this.$drawer.classList.contains('is-open')) {
      this.open();
    } else {
      this.close();
    }
  }

  /**
   * Called when the window is resized.
   */
  private onWindowResize(): void {
    if (window.innerWidth >= 991.98 && this.isOpen) {
      this.close();
    }
  }

  /**
   * Opens the drawer.
   */
  private open(): void {
    this.isOpen = true;

    disableBodyScroll(this.$drawer);

    [].slice.call(document.querySelectorAll('.tc-drawer')).forEach(($drawer) => {
      $drawer.classList.remove('is-open');
    });

    this.$drawer.classList.add('is-open');
  }

  /**
   * Closes the drawer.
   */
  private close(): void {
    this.isOpen = false;

    enableBodyScroll(this.$drawer);

    this.$drawer.classList.remove('is-open');
  }
}
